import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 150px;

  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    width: 100%;
  }
`;

export const StyledTypography = styled.span`
  padding-right: 7px;
  width: 150px;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
`;
